import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import GiftCategoryForm, { GiftCategoryFormData } from "../../../components/admin/giftCategories/GiftCategoryForm";

export default function AdminAddGiftCategoryPage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<GiftCategoryFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });


   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: GiftCategoryFormData) => {
    updateResource(`gift-category`, {languages:data.languages},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries:["gift-categories-by-admin"],
            navigateAfter: () => navigate(`/admin/gift-categories`),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_gift_category" />
        <GiftCategoryForm register={register} errors={errors} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}